module.exports = __webpack_public_path__ + "img/79_17.9d882336.png";